import { DriverPaymentMethod } from "../../../graphql/generated";
import i18next from "i18next";

const billingMethodLabel = (method: DriverPaymentMethod) => {
  return i18next.t(`paymentRules:paymentMethod.${method}`);
};

export default billingMethodLabel;
